import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationLogRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-log',
	path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
	exact: true,
};
